// Create the file input
// method = add > File is being uploaded
// method = show > File is being displayed
// method = replace > File is being replaced
// source = database > File selected from database
// source = device > File selected from device
// source = mediathek > File selected from mediathek

function createFileInput(method, source, type, name, data, id) {
  id = id || uuidv4();

  // console.log(data);

  // Wrapper
  var wrapperEl = $('<div class="file-input__wrapper"/>');
  wrapperEl.attr('data-id', id);
  wrapperEl.attr('data-method', method);
  wrapperEl.attr('data-position', data.position || 'cropped');
  wrapperEl.addClass('file-input__wrapper--' + type);

  var innerWrapperEl = $('<div class="file-input__wrapper-inner"/>');
  wrapperEl.append(innerWrapperEl);

  if (data.id) {
    var formIdInputEl = $(
      '<input name="id" data-form-value="id" type="hidden"/>'
    );
    wrapperEl.append(formIdInputEl);
    formIdInputEl.val(data.id);
  }

  if (data.mediaLibraryId) {
    var formMediaLibraryIdInputEl = $(
      '<input data-form-value="media_library_id" type="hidden"/>'
    );
    wrapperEl.append(formMediaLibraryIdInputEl);
    formMediaLibraryIdInputEl.val(data.mediaLibraryId);
  }

  if (data.replaceId) {
    var formReplaceIdInputEl = $(
      '<input data-form-value="replace_id" type="hidden"/>'
    );
    wrapperEl.append(formReplaceIdInputEl);
    formReplaceIdInputEl.val(data.replaceId);
  }

  // Header
  var headerEl = $('<div class="file-input__header"/>');
  innerWrapperEl.append(headerEl);
  var headerSeparatorEl = $('<div class="file-input__header-separator"/>');

  // Header label
  var label = type == 'image' ? 'Bild' : 'Dokument';
  var labelEl = $('<div class="file-input__label"/>');
  labelEl.html(label + ' <span></span>');
  headerEl.append(labelEl);
  headerEl.append(headerSeparatorEl.clone());

  // Header buttons
  var buttonLabel = $('<div class="file-input__header-button-label"/>');
  buttonLabel.html('Austauschen:');
  headerEl.append(buttonLabel);

  var uploadButtonEl = $(
    '<div class="file-input__header-button file-input__header-button--upload"/>'
  );
  uploadButtonEl.html('Hochladen');
  uploadButtonEl.on('click', function () {
    uploadAndReplaceFile(type, name, id, data.id || null);
  });
  headerEl.append(uploadButtonEl);

  var mediathekButtonEl = $(
    '<div class="file-input__header-button file-input__header-button--mediathek"/>'
  );
  mediathekButtonEl.html('Mediathek');
  mediathekButtonEl.on('click', function () {
    mediathekReplaceFile(type, name, id, data.id || null);
  });
  headerEl.append(mediathekButtonEl);
  headerEl.append(headerSeparatorEl.clone());

  // Presentation button
  if (type == 'image') {
    var mediathekButtonElPresentation = $(
      '<div class="file-input__header-button file-input__header-button--position"/>'
    );
    mediathekButtonElPresentation.html('Ausrichtung');
    mediathekButtonElPresentation.on('click', function () {
      adjustImagePosition(data, wrapperEl);
    });
    headerEl.append(mediathekButtonElPresentation);
    headerEl.append(headerSeparatorEl.clone());
  }

  // Remove button
  var mediathekButtonEl = $(
    '<div class="file-input__header-button file-input__header-button--remove"/>'
  );
  mediathekButtonEl.html('Entfernen');
  mediathekButtonEl.on('click', function () {
    toggleRemoveImage(id);
  });
  headerEl.append(mediathekButtonEl);

  // Options
  if (method == 'show') {
    headerEl.append(headerSeparatorEl.clone());

    var headerOptionsWrapperEl = $(
      '<div class="file-input__header-options-wrapper"/>'
    );
    headerEl.append(headerOptionsWrapperEl);

    var openButton = $(
      '<a href="' +
      data.uri +
      '" target="_blank" class="file-input__header-button file-input__header-button--icon" data-file-header-icon-tooltip="Öffnen"/>'
    );
    openButton.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H3v18h18v-9h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path></svg>'
    );
    headerOptionsWrapperEl.append(openButton);

    var downloadButton = $(
      '<a href="' +
      data.uri +
      '" class="file-input__header-button file-input__header-button--icon" data-file-header-icon-tooltip="Herunterladen" download="' +
      data.filenameOriginal +
      '"/>'
    );
    downloadButton.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19,9h-4V3H9v6H5l7,7L19,9z M5,18v2h14v-2H5z"></path></svg>'
    );
    headerOptionsWrapperEl.append(downloadButton);

    var editButton = $(
      '<a href="/admin/media/' +
      type +
      '/edit/' +
      data.mediaLibraryIndexId +
      '" class="file-input__header-button file-input__header-button--icon" data-file-header-icon-tooltip="In Mediathek bearbeiten"/>'
    );
    editButton.html(
      '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54z"></path></svg>'
    );
    headerOptionsWrapperEl.append(editButton);

    app.fileInputHeaderTooltip && app.fileInputHeaderTooltip.attach();
  }

  // Header spacer
  var headerSpacerEl = $('<div class="file-input__spacer"/>');
  headerEl.append(headerSpacerEl);

  // Move buttons
  var moveUpButtonEl = $(
    '<div class="file-input__header-button file-input__header-button--icon file-input__header-button--move-up"/>'
  );
  moveUpButtonEl.html(
    '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"/></svg>'
  );
  moveUpButtonEl.on('click', function () {
    moveFileContainer(this, 'up');
  });
  headerEl.append(moveUpButtonEl);

  var moveDownButtonEl = $(
    '<div class="file-input__header-button file-input__header-button--icon file-input__header-button--move-down"/>'
  );
  moveDownButtonEl.html(
    '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/></svg>'
  );
  moveDownButtonEl.on('click', function () {
    moveFileContainer(this, 'down');
  });
  headerEl.append(moveDownButtonEl);

  // Container
  var containerEl = $('<div class="file-input__container"/>');
  innerWrapperEl.append(containerEl);

  // Preview
  var previewEl = $('<div class="file-input__preview"/>');
  containerEl.append(previewEl);
  if (data.uri) {
    var previewLinkEl = $(
      '<a class="file-input__preview-link" target="_blank"/>'
    );
    previewLinkEl.attr('href', data.uri);
  } else {
    var previewLinkEl = $('<div class="file-input__preview-link"/>');
  }
  previewEl.append(previewLinkEl);

  switch (type) {
    case 'image':
      var previewItemEl = $('<img class="file-input__preview-image" alt=""/>');
      if (data.uriThumb) {
        previewItemEl.attr('src', data.uriThumb);
      } else {
        var reader = new FileReader();
        reader.onload = function (event) {
          var img = document.createElement('img');
          img.src = event.target.result;

          img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');

            var MAX_WIDTH = 320;
            var MAX_HEIGHT = 240;

            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height = height * (MAX_WIDTH / width);
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width = width * (MAX_HEIGHT / height);
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            var dataurl = canvas.toDataURL(data.file.type);
            previewItemEl.attr('src', dataurl);
          };
        };
        reader.readAsDataURL(data.file);
      }
      break;
    case 'document':
      var previewItemEl = $('<img alt=""/>').attr(
        'src',
        getFileExtensionImage(data.uri ? data.uri : data.file.name)
      );
      break;
  }
  previewLinkEl.append(previewItemEl);

  // Form
  var formEl = $('<div class="file-input__form"/>');
  containerEl.append(formEl);

  // Form title
  var value = data.values.title || '';
  var formTitleWrapperEl = $(
    '<div class="input__wrapper file-input__input-wrapper file-input__input-wrapper--title" data-required/>'
  );
  value && formTitleWrapperEl.attr('data-has-value', '');
  formEl.append(formTitleWrapperEl);
  var formTitleLabelEl = $('<div class="file-input__input-label"/>');
  formTitleLabelEl.html('Titel:');
  formTitleWrapperEl.append(formTitleLabelEl);

  var formTitleInputContainerEl = $(
    '<div class="input__container file-input__input-container"/>'
  );
  formTitleWrapperEl.append(formTitleInputContainerEl);
  var formTitleInputEl = $(
    '<input data-form-value="title" class="textfield textfield--line" type="text" spellcheck="false" maxlength="500"/>'
  );
  formTitleInputEl.attr('name', 'title');
  formTitleInputEl.val(value);
  formTitleInputEl.on('input change', function () {
    var wrapper = $(this).parents('.file-input__wrapper');
    var errorContainer = wrapper.find('.input__error');
    errorContainer.find('[data-error-id="title"]').remove();
    if (!errorContainer.find('> *').length) {
      wrapper.removeAttr('data-error');
    }
  });
  formTitleInputContainerEl.append(formTitleInputEl);

  // Title description
  var formTitleDescriptionWrapperEl = $(
    '<div class="file-input__description-wrapper"/>'
  );
  formTitleWrapperEl.append(formTitleDescriptionWrapperEl);

  var formTitleDescriptionContainerEl = $(
    '<div class="input__description"/>'
  );
  formTitleDescriptionContainerEl.attr('data-input-description', '');
  formTitleDescriptionWrapperEl.append(formTitleDescriptionContainerEl);

  var formTitleDescriptionIconEl = $(
    '<div class="input__description-icon"/>'
  );
  formTitleDescriptionContainerEl.append(formTitleDescriptionIconEl);

  formTitleDescriptionIconEl.html('<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>');

  var formTitleDescriptionTextEl = $(
    '<div class="input__description-text"/>'
  );

  if (type == 'image') {
    var html = 'Der Titel wird auf der Webseite als Bildunterschrift angezeigt. Wählen Sie kurze, prägnante Formulierungen.';
  }
  else {
    var html = 'Wählen Sie kurze, prägnante Formulierungen.';
  }
  formTitleDescriptionTextEl.html(html);
  formTitleDescriptionContainerEl.append(formTitleDescriptionTextEl);

  if (type == 'image') {
    // Form alt title
    var value = data.values.altTitle || '';
    var formAltTitleWrapperEl = $(
      '<div data-form-value="alt_title_enabled" class="input__wrapper file-input__input-wrapper file-input__input-wrapper--alt-title" data-required/>'
    );
    value && formAltTitleWrapperEl.attr('data-has-value', '');
    formAltTitleWrapperEl.attr(
      'data-alt-title-enabled',
      data.altTitleEnabled && method == 'show' ? '1' : '0'
    );
    formAltTitleWrapperEl.data('original-alt-title', data.altTitle || '');
    formEl.append(formAltTitleWrapperEl);
    var formAltTitleLabelEl = $('<div class="file-input__input-label"/>');
    formAltTitleLabelEl.html('Alternativtext:');
    formAltTitleWrapperEl.append(formAltTitleLabelEl);

    var formAltTitleInputContainerEl = $(
      '<div class="input__container file-input__input-container"/>'
    );
    formAltTitleWrapperEl.append(formAltTitleInputContainerEl);
    var formAltTitleInputEl = $(
      '<input data-form-value="alt_title" class="textfield textfield--line" type="text" spellcheck="false" maxlength="500"/>'
    );
    formAltTitleInputEl.on('input change', function () {
      var wrapper = $(this).parents('.file-input__wrapper');
      var errorContainer = wrapper.find('.input__error');
      errorContainer.find('[data-error-id="alt_title"]').remove();
      if (!errorContainer.find('> *').length) {
        wrapper.removeAttr('data-error');
      }
    });
    formAltTitleInputEl.on('keyup', function () {
      var newAltTitle = formAltTitleInputEl.val();
      formAltTitleWrapperEl.data('original-alt-title', newAltTitle);
    });
    formAltTitleInputEl.attr('name', 'alt_title');
    formAltTitleInputEl.val(value);
    formAltTitleInputContainerEl.append(formAltTitleInputEl);

    // Alt title description
    var formAltTitleDescriptionWrapperEl = $(
      '<div class="file-input__description-wrapper"/>'
    );
    formAltTitleWrapperEl.append(formAltTitleDescriptionWrapperEl);

    var formAltTitleDescriptionContainerEl = $(
      '<div class="input__description"/>'
    );
    formAltTitleDescriptionContainerEl.attr('data-input-description', '');
    formAltTitleDescriptionWrapperEl.append(formAltTitleDescriptionContainerEl);

    var formAltTitleDescriptionIconEl = $(
      '<div class="input__description-icon"/>'
    );
    formAltTitleDescriptionContainerEl.append(formAltTitleDescriptionIconEl);

    formAltTitleDescriptionIconEl.html('<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>');

    var formAltTitleDescriptionTextEl = $(
      '<div class="input__description-text"/>'
    );
    var html = 'Der Alternativtext ist wichtig für die Barrierefreiheit der Internetseite. Er gibt Bildinhalte (z.B. Bürgermeister XY, auf einer Wiese stehend, pflanzt mit einem Spaten einen Obstbaum, viele Menschen applaudieren) in kurzen, verständlichen Infotexten wieder und wird über Screenreader für Menschen mit Seheinschränkungen vorgelesen. Der Alternativtext ist auch bedeutsam für das Ranking bei Suchmaschinen.'
    formAltTitleDescriptionTextEl.html(html);
    formAltTitleDescriptionContainerEl.append(formAltTitleDescriptionTextEl);

    // Form author
    var value = data.values.author || '';
    var formAuthorWrapperEl = $(
      '<div class="input__wrapper file-input__input-wrapper file-input__input-wrapper--author" data-required/>'
    );
    value && formAuthorWrapperEl.attr('data-has-value', '');
    formEl.append(formAuthorWrapperEl);
    var formAuthorLabelEl = $('<div class="file-input__input-label"/>');
    formAuthorLabelEl.html('Autor/Copyright:');
    formAuthorWrapperEl.append(formAuthorLabelEl);
    var formAuthorInputContainerEl = $(
      '<div class="input__container file-input__input-container"/>'
    );
    formAuthorWrapperEl.append(formAuthorInputContainerEl);
    var formAuthorInputEl = $(
      '<input data-form-value="author" class="textfield textfield--line" type="text" spellcheck="false" maxlength="500"/>'
    );
    formAuthorInputEl.on('input change', function () {
      var wrapper = $(this).parents('.file-input__wrapper');
      var errorContainer = wrapper.find('.input__error');
      errorContainer.find('[data-error-id="author"]').remove();
      if (!errorContainer.find('> *').length) {
        wrapper.removeAttr('data-error');
      }
    });
    formAuthorInputEl.attr('name', 'author');
    formAuthorInputEl.val(value);
    formAuthorInputContainerEl.append(formAuthorInputEl);

    // Author description
    var formAuthorDescriptionWrapperEl = $(
      '<div class="file-input__description-wrapper"/>'
    );
    formAuthorWrapperEl.append(formAuthorDescriptionWrapperEl);

    var formAuthorDescriptionContainerEl = $(
      '<div class="input__description"/>'
    );
    formAuthorDescriptionContainerEl.attr('data-input-description', '');
    formAuthorDescriptionWrapperEl.append(formAuthorDescriptionContainerEl);

    var formAuthorDescriptionIconEl = $(
      '<div class="input__description-icon"/>'
    );
    formAuthorDescriptionContainerEl.append(formAuthorDescriptionIconEl);

    formAuthorDescriptionIconEl.html('<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>');

    var formAuthorDescriptionTextEl = $(
      '<div class="input__description-text"/>'
    );
    var html = 'Tragen Sie die Person ein, die das Recht am Bild hat (z.B. Urheber, Inhaber von Nutzungsrechten usw.). Verwenden Sie ausschließlich Bilder, bei denen Ihnen die Veröffentlichungsrechte vorliegen!'
    if (source != 'device') {
      html += '<br><br>';
      html += 'Autor/Copyright kann in der Mediathek geändert werden.';
    }
    formAuthorDescriptionTextEl.html(html);
    formAuthorDescriptionContainerEl.append(formAuthorDescriptionTextEl);

    if (source != 'device') {
      formAuthorInputEl.attr('disabled', 'disabled');

      new jBox('Tooltip', {
        addClass: 'tooltip-dark',
        attach: formAuthorInputContainerEl,
        content: 'Autor/Copyright kann in der Mediathek geändert werden',
        delayOpen: 1200,
        position: {
          x: 'left',
          y: 'top'
        },
        offset: {
          y: 10,
          x: 32
        },
        pointer: 'left:24',
        animation: 'move',
        zIndex: 9000,
        onOpen: function () {
          if (
            this.source
              .parents('.file-input__wrapper')[0]
              .hasAttribute('data-remove')
          ) {
            this.close(true);
          }
        }
      });
    }
  }

  // File is being uploaded from device
  if (source == 'device') {
    var formAddToMediaLibraryWrapperEl = $(
      '<div class="file-input__media-library-wrapper"/>'
    );
    formEl.append(formAddToMediaLibraryWrapperEl);

    // Categories
    var formCategoriesWrapperEl = $(
      '<div class="input__wrapper file-input__input-wrapper file-input__input-wrapper--categories"/>'
    );
    formAddToMediaLibraryWrapperEl.append(formCategoriesWrapperEl);
    var formCategoriesLabelEl = $('<div class="file-input__input-label"/>');
    formCategoriesLabelEl.html('Tags:');
    formCategoriesWrapperEl.append(formCategoriesLabelEl);
    var formCategoriesInputContainerEl = $(
      '<div class="input__container file-input__input-container"/>'
    );
    formCategoriesWrapperEl.append(formCategoriesInputContainerEl);
    var formCategoriesInputEl = $(
      '<select multiple="multiple" data-form-value="tags"/>'
    );

    $.each(fileCategories[type], function (index, item) {
      formCategoriesInputEl.append(
        $('<option value="' + item.id + '"/>').html(item.title)
      );
    });
    formCategoriesInputContainerEl.append(formCategoriesInputEl);

    $(formCategoriesInputEl).select2({
      placeholder: 'Tags wählen...',
      width: '100%',
      closeOnSelect: false,
      multiple: true
    });

    // Categories description
    var formCategoriesDescriptionWrapperEl = $(
      '<div class="file-input__description-wrapper"/>'
    );
    formCategoriesWrapperEl.append(formCategoriesDescriptionWrapperEl);

    var formCategoriesDescriptionContainerEl = $(
      '<div class="input__description"/>'
    );
    formCategoriesDescriptionContainerEl.attr('data-input-description', '');
    formCategoriesDescriptionWrapperEl.append(formCategoriesDescriptionContainerEl);

    var formCategoriesDescriptionIconEl = $(
      '<div class="input__description-icon"/>'
    );
    formCategoriesDescriptionContainerEl.append(formCategoriesDescriptionIconEl);

    formCategoriesDescriptionIconEl.html('<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>');

    var formCategoriesDescriptionTextEl = $(
      '<div class="input__description-text"/>'
    );

    if (type == 'image') {
      var html = 'Den Bildern, die sie verwenden, können Sie Stichwörter aus einer Auswahlliste zuordnen. Das erleichtert später die Suche nach ähnlichen Fotos in der Mediathek.';
    }
    else {
      var html = 'Den Dokumenten, die sie verwenden, können Sie Stichwörter aus einer Auswahlliste zuordnen. Das erleichtert später die Suche nach ähnlichen Dokumenten in der Mediathek.';
    }
    formCategoriesDescriptionTextEl.html(html);
    formCategoriesDescriptionContainerEl.append(formCategoriesDescriptionTextEl);

    if (type == 'image') {
      // Social media
      var formSocialMediaWrapperEl = $(
        '<div data-form-value="social_media_enabled" class="input__wrapper file-input__input-wrapper file-input__input-wrapper--social-media"/>'
      );
      formEl.append(formSocialMediaWrapperEl);

      var formSocialMediaLabelEl = $('<div class="file-input__input-label"/>');
      formSocialMediaLabelEl.html('&nbsp;');
      formSocialMediaWrapperEl.append(formSocialMediaLabelEl);

      var formSocialMediaOptionContainerEl = $(
        '<div class="file-input__input-option-container file-input__input-option-container--social-media"/>'
      );
      formSocialMediaWrapperEl.append(formSocialMediaOptionContainerEl);
      formSocialMediaOptionContainerEl.html(
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path class="file-input__input-option-icon-blank" d="M19 5v14H5V5h14m2-2H3v18h18V3z"/><path class="file-input__input-option-icon-checked" d="M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>'
      );
      var formSocialMediaOptionLabelEl = $(
        '<div class="file-input__input-option-label"/>'
      );
      formSocialMediaOptionLabelEl.html('Für Social Media freigegeben');
      formSocialMediaOptionContainerEl.on('click', function () {
        if (
          wrapperEl[0].hasAttribute('data-remove') ||
          $(this).hasClass('file-input__input-option-container--disabled')
        ) {
          return;
        }
        var isEnabled = formSocialMediaWrapperEl.attr('data-social-media-enabled') == '1';
        formSocialMediaWrapperEl.attr(
          'data-social-media-enabled',
          isEnabled ? '0' : '1'
        );
      });
      formSocialMediaOptionContainerEl.append(formSocialMediaOptionLabelEl);

      // Social media description
      var formSocialMediaDescriptionWrapperEl = $(
        '<div class="file-input__description-wrapper"/>'
      );
      formSocialMediaWrapperEl.append(formSocialMediaDescriptionWrapperEl);

      var formSocialMediaDescriptionContainerEl = $(
        '<div class="input__description"/>'
      );
      formSocialMediaDescriptionContainerEl.attr('data-input-description', '');
      formSocialMediaDescriptionWrapperEl.append(formSocialMediaDescriptionContainerEl);

      var formSocialMediaDescriptionIconEl = $(
        '<div class="input__description-icon"/>'
      );
      formSocialMediaDescriptionContainerEl.append(formSocialMediaDescriptionIconEl);

      formSocialMediaDescriptionIconEl.html('<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>');

      var formSocialMediaDescriptionTextEl = $(
        '<div class="input__description-text"/>'
      );
      var html = 'Mit Setzen des Hakens darf das Bild für Social Media (Facebook, Instagram o.ä.) verwendet werden';
      formSocialMediaDescriptionTextEl.html(html);
      formSocialMediaDescriptionContainerEl.append(formSocialMediaDescriptionTextEl);

      // Terms
      var formTermsAcceptedWrapperEl = $(
        '<div data-form-value="consent_available" class="input__wrapper file-input__input-wrapper file-input__input-wrapper--terms"/>'
      );
      formEl.append(formTermsAcceptedWrapperEl);

      var formTermsAcceptedLabelEl = $('<div class="file-input__input-label"/>');
      formTermsAcceptedLabelEl.html('&nbsp;');
      formTermsAcceptedWrapperEl.append(formTermsAcceptedLabelEl);

      var formTermsAcceptedOptionContainerEl = $(
        '<div class="file-input__input-option-container file-input__input-option-container--terms"/>'
      );
      formTermsAcceptedWrapperEl.append(formTermsAcceptedOptionContainerEl);
      formTermsAcceptedOptionContainerEl.html(
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"><path class="file-input__input-option-icon-blank" d="M19 5v14H5V5h14m2-2H3v18h18V3z"/><path class="file-input__input-option-icon-checked" d="M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>'
      );
      var formTermsAcceptedOptionLabelEl = $(
        '<div class="file-input__input-option-label"/>'
      );
      formTermsAcceptedOptionLabelEl.html('Falls Personen abgebildet sind: Einwilligungserklärungen, dass die Personen abgebildet werden dürfen, sind vorhanden');
      formTermsAcceptedOptionContainerEl.on('click', function () {
        if (
          wrapperEl[0].hasAttribute('data-remove') ||
          $(this).hasClass('file-input__input-option-container--disabled')
        ) {
          return;
        }
        var isEnabled = formTermsAcceptedWrapperEl.attr('data-terms-accepted') == '1';
        formTermsAcceptedWrapperEl.attr(
          'data-terms-accepted',
          isEnabled ? '0' : '1'
        );
      });
      formTermsAcceptedOptionContainerEl.append(formTermsAcceptedOptionLabelEl);

      // Terms description
      var formTermsDescriptionWrapperEl = $(
        '<div class="file-input__description-wrapper"/>'
      );
      formTermsAcceptedWrapperEl.append(formTermsDescriptionWrapperEl);

      var formTermsDescriptionContainerEl = $(
        '<div class="input__description"/>'
      );
      formTermsDescriptionContainerEl.attr('data-input-description', '');
      formTermsDescriptionWrapperEl.append(formTermsDescriptionContainerEl);

      var formTermsDescriptionIconEl = $(
        '<div class="input__description-icon"/>'
      );
      formTermsDescriptionContainerEl.append(formTermsDescriptionIconEl);

      formTermsDescriptionIconEl.html('<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>');

      var formTermsDescriptionTextEl = $(
        '<div class="input__description-text"/>'
      );
      var html = 'Mit Setzen des Hakens bestätigen Sie, dass von den Personen auf dem Bild (falls vorhanden) ausgefüllte und unterschriebene Einwilligungserklärungen vorhanden sind.';
      formTermsDescriptionTextEl.html(html);
      formTermsDescriptionContainerEl.append(formTermsDescriptionTextEl);
    }
  }

  // Errors
  wrapperEl.append('<div class="input__error"/>');

  // Append or replace
  var wrapper = $('.input__wrapper[data-form-input="' + name + '"]');
  var inputWrapper = $('.file-input__wrapper[data-id="' + id + '"]');
  if (inputWrapper.length) {
    inputWrapper.replaceWith(wrapperEl);
  } else {
    wrapper.find('.file-inputs__wrapper').append(wrapperEl);
  }

  // Add events
  addTextfieldEvents();

  // Update values
  wrapper.attr('data-has-value', '');
  updateFileNumbers(wrapper);
  updateFileAmounts(wrapper);
  updateUploadText(wrapper);

  // Remove error
  wrapper.removeAttr('data-error');

  // Apply tooltips
  app.tooltipInputDescription && app.tooltipInputDescription.attach();
}

// Update the numbers of images or documents

function updateFileNumbers(wrapper) {
  if (!wrapper) {
    wrapper = $('.input__wrapper[data-input-type="file"]');
  }

  $.each(wrapper, function (index, wrapper) {
    var containers = $(wrapper).find('.file-input__wrapper');
    if (containers.length > 1) {
      $.each(containers, function (index, container) {
        $(container)
          .find('.file-input__label span')
          .html(index + 1);
      });
    } else if (containers.length == 1) {
      containers.find('.file-input__label span').html('');
    }
  });
}

// Update the amount of images or documents

function updateFileAmounts(wrapper) {
  if (!wrapper) {
    wrapper = $('.input__wrapper[data-input-type="file"]');
  }

  $.each(wrapper, function (index, item) {
    $(item).attr('data-amount', $(item).find('.file-input__wrapper').length);
    var limit = parseInt($(item).attr('data-limit'));
    var amount = parseInt($(item).attr('data-amount'));
    if (limit) {
      if (limit <= amount) {
        $(item).attr('data-add-more', 0);
      } else {
        $(item).attr('data-add-more', 1);
      }
    }
  });
}

// Update the upload label texts

function updateUploadText(wrapper) {
  if (!wrapper) {
    wrapper = $('.input__wrapper[data-input-type="file"]');
  }

  wrapper.each(function (index, item) {
    var values = $(item).attr('data-amount');
    var labelEl = $(item).find('.add-file__label');
    labelEl.html(
      labelEl.attr(values >= 1 ? 'data-text-more' : 'data-text-initial')
    );
  });
}

$(function () {
  updateUploadText();
});

// Change order

function moveFileContainer(element, direction) {
  if (app.movingFileContainer) {
    return;
  }

  var wrapper = $(element).parents('.input__wrapper');
  var container = $(element).parents('.file-input__wrapper');
  var containerSwap = container[direction == 'up' ? 'prev' : 'next']();

  if (container[0].hasAttribute('data-remove')) {
    return;
  }

  if (!containerSwap || !containerSwap.length) {
    return;
  }

  formUserInput = true;
  app.movingFileContainer = true;

  var containerTop = container.offset().top;
  var containerHeight = container.outerHeight();
  var containerSwapTop = containerSwap.offset().top;
  var containerSwapHeight = containerSwap.outerHeight();

  if (direction == 'up') {
    var differenceTop = containerTop - containerSwapTop;
  } else {
    var differenceTop =
      containerTop - containerSwapTop - containerSwapHeight + containerHeight;
  }

  container.animate(
    {
      y: differenceTop
    },
    {
      duration: 350,
      step: function (val) {
        container.css('transform', `translateY(${val * -1}px)`);
      },
      complete: function () {
        container.removeAttr('style');
      }
    }
  );

  if (direction == 'up') {
    var differenceSwapTop =
      containerTop - containerSwapTop - containerSwapHeight + containerHeight;
  } else {
    var differenceSwapTop = containerTop - containerSwapTop;
  }

  containerSwap.animate(
    {
      y: differenceSwapTop
    },
    {
      duration: 350,
      step: function (val) {
        containerSwap.css('transform', `translateY(${val}px)`);
      },
      complete: function () {
        containerSwap.removeAttr('style');
        container[direction == 'up' ? 'insertBefore' : 'insertAfter'](
          containerSwap
        );
        app.movingFileContainer = false;
        updateFileNumbers(wrapper);
      }
    }
  );

  updateFileNumbers(wrapper);
}

// Toggle remove status

function toggleRemoveImage(id) {
  var inputWrapper = $('.file-input__wrapper[data-id="' + id + '"]');
  var wrapper = inputWrapper.parents('.input__wrapper');

  var required = wrapper[0].hasAttribute('data-required');
  var limit = parseInt(wrapper.attr('data-limit'));
  var amount = parseInt(wrapper.attr('data-amount'));

  if (required && limit == amount) {
    return;
  }

  formUserInput = true;

  if (inputWrapper.attr('data-method') == 'add') {
    inputWrapper.remove();
    if (!wrapper.find('.file-input__wrapper').length) {
      wrapper.removeAttr('data-has-files');
    }
    updateFileNumbers(wrapper);
    updateFileAmounts(wrapper);
    updateUploadText(wrapper);
    return;
  }

  var removing = inputWrapper[0].hasAttribute('data-remove');
  if (removing) {
    inputWrapper[0].removeAttribute('data-remove');
  } else {
    inputWrapper.attr('data-remove', '');
  }

  inputWrapper.find('input.textfield').each(function (index, item) {
    if (removing) {
      if (item.hasAttribute('data-removing-disabled')) {
        $(item).removeAttr('disabled', 'disabled');
        $(item).removeAttr('data-removing-disabled');
      }
    } else {
      if (!item.hasAttribute('disabled')) {
        $(item).attr('disabled', 'disabled');
        $(item).attr('data-removing-disabled', '');
      }
    }
  });
}

function adjustImagePosition(data, parentWrapper) {

  if (!app.adjustImageModal) {
    app.adjustImageModal = new jBox('Modal', {
      addClass: 'modal__wrapper',
      adjustDistance: 16,
      closeButton: 'title',
      width: 432,
      title: 'Bild-Ausrichtung',
      content: '',
      createOnInit: true,
      zIndex: 11000,
      onCreated: function () {
        // Fix close button
        setModalCloseButton(this.wrapper);
      }
    });
  }

  app.adjustImageModal.setContent('');

  var wrapper = $('<div class="modal-adjust__wrapper"/>');

  if (data.height && data.width) {
    var ratio = data.height / data.width;
    if (ratio != 3 / 4) {
      wrapper.addClass('image-ratio-' + (ratio > 3 / 4 ? 'horizontal' : 'vertical'));
    } else {
      wrapper.addClass('image-ratio-fit');
    }
  }

  var container = $('<div class="modal-adjust__wrapper"/>');
  container.appendTo(wrapper);

  var imageSrc = data.uriThumb;

  if (!imageSrc) {
    imageSrc = parentWrapper.find('.file-input__preview-image').attr('src');
  }

  var imageContainer = $('<div class="modal-adjust__image"/>');
  imageContainer.css({
    backgroundImage: 'url(\'' + imageSrc + '\')'
  });

  imageContainer.attr('data-position', parentWrapper.attr('data-position') || 'cropped');
  imageContainer.appendTo(container);

  var imageOptions = $('<div class="modal-adjust__image-options"/>');
  imageOptions.appendTo(container);

  var imageOptionCenter = $('<div class="modal-adjust__image-option -center"/>');
  imageOptionCenter.html('Zugeschnitten zum Verhältnis 4:3 (Zentriert)');
  if (parentWrapper.attr('data-position') == 'cropped') {
    imageOptionCenter.addClass('-active');
  }
  imageOptionCenter.on('click', function () {
    $('.modal-adjust__image-option').removeClass('-active');
    $(this).addClass('-active');
    imageContainer.attr('data-position', 'cropped');
    parentWrapper.attr('data-position', 'cropped');
  });
  imageOptionCenter.appendTo(imageOptions);

  var imageOptionCT = $('<div class="modal-adjust__image-option -top"/>');
  imageOptionCT.html('Zugeschnitten zum Verhältnis 4:3 (Oben)');
  if (parentWrapper.attr('data-position') == 'cropped_top') {
    imageOptionCT.addClass('-active');
  }
  imageOptionCT.on('click', function () {
    $('.modal-adjust__image-option').removeClass('-active');
    $(this).addClass('-active');
    imageContainer.attr('data-position', 'cropped_top');
    parentWrapper.attr('data-position', 'cropped_top');
  });
  imageOptionCT.appendTo(imageOptions);

  var imageOptionCB = $('<div class="modal-adjust__image-option -bottom"/>');
  imageOptionCB.html('Zugeschnitten zum Verhältnis 4:3 (Unten)');
  if (parentWrapper.attr('data-position') == 'cropped_bottom') {
    imageOptionCB.addClass('-active');
  }
  imageOptionCB.on('click', function () {
    $('.modal-adjust__image-option').removeClass('-active');
    $(this).addClass('-active');
    imageContainer.attr('data-position', 'cropped_bottom');
    parentWrapper.attr('data-position', 'cropped_bottom');
  });
  imageOptionCB.appendTo(imageOptions);

  var imageOptionLC = $('<div class="modal-adjust__image-option -left"/>');
  imageOptionLC.html('Zugeschnitten zum Verhältnis 4:3 (Links)');
  if (parentWrapper.attr('data-position') == 'cropped_left') {
    imageOptionLC.addClass('-active');
  }
  imageOptionLC.on('click', function () {
    $('.modal-adjust__image-option').removeClass('-active');
    $(this).addClass('-active');
    imageContainer.attr('data-position', 'cropped_left');
    parentWrapper.attr('data-position', 'cropped_left');
  });
  imageOptionLC.appendTo(imageOptions);

  var imageOptionRC = $('<div class="modal-adjust__image-option -right"/>');
  imageOptionRC.html('Zugeschnitten zum Verhältnis 4:3 (Rechts)');
  if (parentWrapper.attr('data-position') == 'cropped_right') {
    imageOptionRC.addClass('-active');
  }
  imageOptionRC.on('click', function () {
    $('.modal-adjust__image-option').removeClass('-active');
    $(this).addClass('-active');
    imageContainer.attr('data-position', 'cropped_right');
    parentWrapper.attr('data-position', 'cropped_right');
  });
  imageOptionRC.appendTo(imageOptions);

  wrapper.appendTo(app.adjustImageModal.content);

  app.adjustImageModal.open();
}
